import { uiText } from '../../i18n/uiText';
import React from 'react';
import {AlertTriangle, CheckCircle, Clock, Loader} from 'lucide-react';

export function saveStatus({saving, error, recovery, dirty, draftSynced, savedAt}) {
  if(saving) return {state:'saving',label:uiText("Сохраняется"),Icon:Loader};
  if(error) return {state:'error',label:uiText("Ошибка сохранения"),Icon:AlertTriangle};
  if(recovery) return {state:'recovery',label:uiText("Есть черновик для восстановления"),Icon:Clock};
  if(dirty) return {state:'dirty',label:draftSynced?uiText("Черновик на сервере · требуется подтверждение"):uiText("Есть несохранённые изменения"),Icon:Clock};
  return {state:'saved',label:savedAt?uiText("Сохранено"):uiText("Нет несохранённых изменений"),Icon:CheckCircle};
}
export default function SaveStatus(props) {
  const {state,label,Icon}=saveStatus(props);
  return <div className={`ap-save-status ap-save-status--${state}`} role="status" aria-live="polite"><Icon size={16} aria-hidden="true"/><span>{label}{props.error && <small>{props.error}</small>}</span></div>;
}
